import MerchantIbanApi from '@/api/iban'

const state = {
  isFetching: false,
  error: null,
}

const getters = {
  isFetching: (state) => state.isFetching,
  error: (state) => state.error,
}

const mutations = {
  SET_FETCHING: (state, { key, value }) => {
    state[key] = value
  },
  SET_ERROR: (state, error) => {
    state.error = error
  },
}

const actions = {
  async submitIbanVerification({ commit }, dataToBeSent) {
    try {
      commit('SET_FETCHING', { key: 'isFetching', value: true })

      const { data } = await MerchantIbanApi.submitIbanVerification(
        dataToBeSent
      )

      commit('SET_IBAN_VERIFICATION_DATA', { data })

      return data
    } catch (error) {
      commit('SET_ERROR', error)

      throw error
    } finally {
      commit('SET_FETCHING', { key: 'isFetching', value: false })
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
